import type { SVGProps } from "react";
export default function SvgBuilding(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-building-icon lucide-building"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 10h.01" />
			<path d="M12 14h.01" />
			<path d="M12 6h.01" />
			<path d="M16 10h.01" />
			<path d="M16 14h.01" />
			<path d="M16 6h.01" />
			<path d="M8 10h.01" />
			<path d="M8 14h.01" />
			<path d="M8 6h.01" />
			<path d="M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" />
			<rect width={16} height={20} x={4} y={2} rx={2} />
		</svg>
	);
}
